export default __webpack_public_path__ + "static/media/3-Sevan-Har identiteten din endret seg etter at du kom til Norge.579408bf.mp4";